import { backlogStorageValidate } from "../../application/dtos/backlog_storage_validate";

export class BacklogStorageEntity {
    constructor({ storage, pending_operations, pending_storage }){
        this.storage = storage;
        this.pending_operations = pending_operations;
        this.pending_storage = pending_storage;
    }

    isValid() {
        return backlogStorageValidate(this);
    }
}